export type GstMode = 'GST' | 'NON-GST'

const GST_KEY = 'app_gst_mode'

export const getGstMode = ():GstMode =>{
    return (localStorage.getItem(GST_KEY) as GstMode) || 'GST'
}

export const setGstMode = (mode: GstMode) =>{
    localStorage.setItem(GST_KEY, mode)
    window.dispatchEvent(new Event('gst-mode-changed'))
}

export const isGstEnabled =(): boolean=>{
    return getGstMode() === 'GST';
}